import { AchievementDetailPathSchema } from '@milestone-portal/schema/path.schema';
import { ResponsiveLayout } from '@milestone-portal/ui/ResponsiveLayout/ResponsiveLayout';
import { createFileRoute } from '@tanstack/react-router';

import { AchievementDetail } from './-components/AchievementDetail';
import { MobileAchievementDetail } from './-components/MobileAchievementDetail';
import { NftDetailSkeleton } from './-components/pending/NftDetailSkeleton';
import { AchievementDetailContext } from './-logic/AchievementDetailContext';
import { useAchievementDetail } from './-logic/useAchievementDetail';

export const Route = createFileRoute('/assets/achievement/$achievementId')({
  component: AchievementDetailPage,
  params: {
    parse: AchievementDetailPathSchema.parse,
  },
  pendingComponent: NftDetailSkeleton,
});

function AchievementDetailPage() {
  return (
    <AchievementDetailContext.Provider value={useAchievementDetail()}>
      <ResponsiveLayout
        desktop={<AchievementDetail />}
        mobile={<MobileAchievementDetail />}
      />
    </AchievementDetailContext.Provider>
  );
}
